export const MuiDialogContent = {
    MuiDialogContent: {
        styleOverrides: {
            root: {
                padding: '0 24px 24px 24px',
            },
        },
    },
};
